import cns from "classnames";

const ButtonGroup = ({
  className,
  children,
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={cns("flex gap-2", className)}>{children}</div>;

export default ButtonGroup;
